export class Dto {
  constructor(FIELDS = {}, data = {}) {
    Object.values(FIELDS).forEach(key => (this[key] = typeof data[key] === 'undefined' ? null : data[key]));
  }
}
